export default {
  /** 显示错误信息 */
  showMsg: function (vm, errorInfo) {
    let htmlTemp = '<div class="baize-alert-container">' +
        '<div class="baize-alert-header">' +
          '<div class="baize-alert-title">系统错误</div>' +
          '<button class="baize-alert-header-btn baize-alert-btn-close"><i class="fa fa-close"></i></button>' +
        '</div>' +
        '<div class="baize-alert-content" style="width: ' + (window.innerWidth - 200) + 'px; height: ' + (window.innerHeight - 200) + 'px">' +
          '<div class="baize-alert-msg">' +
          '<p class="msg-topic">对不起，出现系统级错误。<br/>请将下列信息发送给系统管理人员：</p>' +
          '<div class="baize-alert-msg-ctn">' +
            '<span style="font-size:12px;">[浏览器]: ' + window.navigator.userAgent + '<br/>' + '[地址]: ' + window.location.href + '</span><br/>' +
            '<span style="font-size:12px;">[发生时间]: ' + errorInfo.dateTime + '</span><br/>' +
            '<span style="font-size:12px;">[线程号]: ' + errorInfo.threadName + '</span><br/>' +
            '<span class="msg-error">' + errorInfo.message + '</span><br/>' +
          '</div>' +
          '</div>' +
        '</div>' +
        '<div class="baize-alert-btns">' +
          '<button class="baize-alert-button baize-alert-btn-submit baize-alert-color-danger"><span>关闭</span></button>' +
          '<button class="baize-alert-button baize-alert-btn-copy"><span>复制到剪切板</span></button>' +
        '</div>' +
      '</div>'
    let $baizeModal = document.createElement('div')
    $baizeModal.setAttribute('class', 'baize-modal')
    let $msgModal = document.createElement('div')
    $msgModal.setAttribute('class', 'baize-alert-modal')
    $msgModal.innerHTML = htmlTemp
    /*
     * 复制按钮
     */
    $msgModal.getElementsByClassName('baize-alert-btn-copy')[0].onclick = function () {
      let $msgP = $msgModal.getElementsByClassName('baize-alert-msg-ctn')[0]
      if (document.body.createTextRange) {
        let range = document.body.createTextRange()
        range.moveToElementText($msgP)
        range.select()
      } else if (window.getSelection) {
        let selection = window.getSelection()
        let range = document.createRange()
        range.selectNodeContents($msgP)
        selection.removeAllRanges()
        selection.addRange(range)
      } else {
        // 提示复制失败
        vm.$notify({position: 'bottom-right', type: 'error', message: '复制失败'})
      }
      document.execCommand('Copy')
    }
    /*
     * 关闭按钮
     */
    $msgModal.getElementsByClassName('baize-alert-btn-submit')[0].onclick = function () {
      document.body.removeChild($msgModal)
      document.body.removeChild($baizeModal)
    }
    /*
     * 窗口关闭按钮
     */
    $msgModal.getElementsByClassName('baize-alert-btn-close')[0].onclick = function () {
      document.body.removeChild($msgModal)
      document.body.removeChild($baizeModal)
    }
    document.body.appendChild($msgModal)
    document.body.appendChild($baizeModal)
  }
}



// WEBPACK FOOTER //
// ./src/baize/src/ExceptionHandlerWindow.js